import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesTertiaryBlockDefaultStyles } from "../constants";

export interface SalesBlock10Props extends ComponentPropsWithRef<"div"> {
  backgroundImage?: {
    signed_id: string;
    placeholder?: string;
  };
  leftContent: ReactNode;
  rightContent: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const SalesBlock10 = forwardRef<HTMLDivElement, SalesBlock10Props>(
  ({ leftContent, rightContent, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesTertiaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-mx-auto wb-flex wb-max-w-4xl wb-flex-col wb-gap-6 md:wb-flex-row md:wb-gap-11">
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-6">
                  {leftContent}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-6">
                  {rightContent}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock10.displayName = "SalesBlock10";
